import { toError } from '@/utils/errors';

import { GET, POST } from './base/base-request';
import { ENDPOINTS } from './endpoints';
import { StandardResponse } from './standard-response';

export interface AIConversation {
  id: string; // UUID
  created_at: string; // ISO timestamp
  user_email: string;
  initial_msj: string; // Original user query
}

export interface SourceRef {
  document_id: string;
  document: string;
  section?: string | null;
  page?: number | null;
}

export interface OculomicsSearchResponse {
  answer: string;
  key_findings: string[];
  supporting_quotes: string[];
  sources: SourceRef[];
  additional_context?: string | null;
}

export interface AIRawOutput {
  id: string;
  role: string;
  type: string;
  content: {
    annotations?: unknown[];
    parsed?: OculomicsSearchResponse;
    text?: string;
    type?: string;
    logprobs?: unknown[];
  }[];
  status: string;
}

export interface AIRaw {
  output?: AIRawOutput[];
  [key: string]: unknown;
}

export interface AIMessage {
  id: string; // UUID
  created_at: string; // ISO timestamp
  user_email: string;
  conversation_id: string;
  direction: 'inbound' | 'outbound';
  content: string;
  ai_raw?: AIRaw;
}

// POST /ai-search
export interface StartSearchData {
  conversation: AIConversation;
  messages: AIMessage[];
}

export async function AISearch(query: string) {
  try {
    const res = await POST<StandardResponse<StartSearchData>>(ENDPOINTS.AI_SEARCH, { query });
    return res.data;
  } catch (err) {
    return Promise.reject(toError(err));
  }
}

export async function AIConversations() {
  try {
    const res = await GET<StandardResponse<AIConversation[]>>(ENDPOINTS.AI_SEARCH);
    return res.data;
  } catch (err) {
    return Promise.reject(toError(err));
  }
}

export async function AIConversationMessages(conversationId: string) {
  try {
    const res = await GET<StandardResponse<AIMessage[]>>(ENDPOINTS.AI_SEARCH_MESSAGES, {
      parameters: { conversationId },
    });
    return res.data;
  } catch (err) {
    return Promise.reject(toError(err));
  }
}
